import React from "react";
import { Routes, Route } from "react-router-dom";
import Homepage from "./pages/Homepage";
import ServicesPage from "./pages/ServicesPage";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";


const AllRoutes = () => {
  return (
    <Routes>
      {/* Main Pages */}
      <Route path="/" element={<Homepage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/about-us" element={<AboutUs/>} />
      <Route path="/contact-us" element={<ContactUs/>} />

      
     
    </Routes>
  );
};

export default AllRoutes;